<template>
  <footer class="app-footer">
    <span class="ml-auto">copyright © 2018 by <a href="#">Diqit</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue